import { useEffect } from "react";
import { Location, useLocation } from "react-router-dom";

export function useRouteChange(action: (location: Location) => void): void {
  const location = useLocation();
  useEffect(() => {
    action(location);
  }, [action, location]);
}
